exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-ortho-arch__actions{display:flex;gap:10px;justify-content:center;align-items:center}", ""]);

// exports
